export enum ChoiceStatus {
  NORMAL,
  SELECTED,
  CORRECT,
  FAILURE,
  TRANSPARENT
}
